var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigleLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_1513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.22462V13.7754H20V6.22462H0ZM19.0149 12.7904H0.98492V7.20954H19.0151V12.7904H19.0149ZM3.57978 11.9174H2.06576V11.5259H2.5678V8.47443H2.06576V8.08288H3.57978V8.47443H3.07782V11.5262H3.57974L3.57978 11.9174Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_1513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigleLineIcon);
export default __webpack_public_path__ + "static/media/sigle-line-icon.daeb0c4a07acefa24083255df7ff0e4e.svg";
export { ForwardRef as ReactComponent };